<template>
  <div class="customer">
    <el-collapse v-model="selectedAccount" accordion>
      <el-collapse-item
        v-for="(customer, index) in customers"
        :key="index"
        :name="customer.id"
      >
        <template slot="title">
          <el-row>
            <el-col :span="12" class="alignItem">
              <p class="text">{{ customer.name }}</p>
            </el-col>
            <el-col :span="12" class="d-flex">
              <el-popconfirm
                class="mr-auto"
                confirm-button-text="موافق"
                cancel-button-text="إلغاء"
                icon="el-icon-info"
                icon-color="red"
                :title="
                  'هل تريد عرض حساب العميل /  ' + ' ' + customer.name + ' ؟'
                "
                @confirm="goTo('/customers/report', customer)"
              >
                <div slot="reference">
                  <p class="text">سجل الحركات</p>
                </div>
              </el-popconfirm>
              <p class="num">
                {{
                  numberToFixed(
                    Number(customer.account) + Number(customer.balance)
                  )
                }}
              </p>
              <!-- @click.stop -->
              <input
                @keyup.enter.stop
                @click.stop
                type="number"
                :class="'paied' + customer.id"
                class="form-control paied"
                placeholder="قيمه التحصيل"
                @keyup.enter="pay(customer)"
                v-model="customer.paied"
              />
              <button
                @click="pay(customer)"
                class="btn"
                :class="btnColor"
                @click.stop
              >
                تم
              </button></el-col
            >
          </el-row>
        </template>
        <el-row>
          <el-col :span="2">
            <el-popconfirm
              class="h mr-auto"
              confirm-button-text="موافق"
              cancel-button-text="إلغاء"
              icon="el-icon-info"
              icon-color="red"
              :title="
                'هل تريد عرض حساب العميل /  ' + ' ' + customer.name + ' ؟'
              "
              @confirm="goTo('/customers/report', customer)"
            >
              <div slot="reference">
                <button class="main-border" style="margin-top: 5px">
                  عرض <br />
                  الحساب
                </button>
              </div>
            </el-popconfirm>
          </el-col>
          <el-col :span="22">
            <el-table
              class="mt-2"
              align="right"
              v-if="tableData.length > 0"
              :data="tableData"
              border
              style="width: 100%"
            >
              <el-table-column label="#" type="index" width="50">
              </el-table-column>
              <el-table-column
                sortable
                width="95"
                label="السند"
                prop="operation_id"
              >
              </el-table-column>

              <el-table-column
                sortable
                width="160"
                label="التوقيت"
                prop="created_at"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.created_at | moment(" Do / MM / YYYY | h:mm A")
                  }}
                </template>
              </el-table-column>
              <el-table-column width="400" label="بيان" prop="description">
              </el-table-column>
              <el-table-column label="مدين">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 1">{{ scope.row.amount }}</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column label="دائن">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 0">{{ scope.row.amount }}</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column label="بواسطة" prop="user.name">
              </el-table-column>
            </el-table>
            <!-- <el-table
              class="mt-2"
              align="right"
              v-if="report.length > 0"
              :data="report"
              border
              style="width: 100%"
            >
              <el-table-column label="#" type="index" width="50">
              </el-table-column>
              <el-table-column sortable width="100" label="السند" prop="id">
              </el-table-column>

              <el-table-column sortable label="التوقيت" prop="donne_at">
              </el-table-column>
              <el-table-column width="250" label="بيان" prop="comment">
              </el-table-column>
              <el-table-column label="الكمية" prop="qty"> </el-table-column>
              <el-table-column label="الرصيد" prop="cost"> </el-table-column>
              <el-table-column label="الاجمالي" prop="total">
              </el-table-column> </el-table
          > -->
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import axiosApi from "@/plugins/axios.js";

export default {
  props: {
    customers: {
      type: Array,
    },
    btnColor: {
      type: String,
    },
  },
  data() {
    return {
      selectedAccount: "",
      report: [],
      tableData: [],
    };
  },
  watch: {
    selectedAccount: function (newValue) {
      // alert(newValue)
      this.getCustomerReportNew(newValue);
      if (this.selectedAccount != "") {
        document.querySelector(".paied" + this.selectedAccount).focus();
      } else {
        document.querySelector(".paied").focus();
      }
    },
  },
  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    pay(customer) {
      if (customer.paied > 0) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let paymentForm = {
          paied: customer.paied,
          customer: customer,
          inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
            .id,
        };
        axiosApi
          .post("customers/pay", paymentForm)
          .then(() => {
            this.$notify({
              title: "تمت العملية بنجاح",
              message: "تم حفظ عملية التحصيل بنجاح",
              type: "success",
              duration: 1500,
            });
            setTimeout(() => {
              location.reload();
            }, 500);
          })
          .catch(() => {
            loading.close();
            this.$notify({
              title: "حدث خطأ",
              message: "عفوا لم تتم العملية ",
              type: "error",
              duration: 1500,
            });
          });
      } else {
        this.$notify({
          title: "حدث خطأ",
          message: "حدد مبلغ صحيح أولاً",
          type: "error",
          duration: 1500,
        });
      }
    },
    goTo(routerName, customer) {
      this.$router.push({
        path: routerName,
        query: { customer_id: customer.id },
      });
    },
    getCustomerReport(account) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `customers/interval-report/${account}`;
      axiosApi
        .get(url)
        .then((response) => {
          this.tableData = response.data.customer_report;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    getCustomerSummary(account) {
      this.report = [];
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `customers/account-summary/${account}?limit=5`;
      axiosApi
        .get(url)
        .then((response) => {
          this.report = response.data.customer_report;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    getCustomerReportNew(account) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `/logs/customers/${account}?limit=10`;
      axiosApi
        .get(url)
        .then((response) => {
          this.tableData = response.data.customer_report;
          const vm = this;
          let sum = 0;
          this.tableData.map(function (value) {
            if (value["type"] == 1) {
              sum += value["amount"];
            } else {
              sum -= value["amount"];
            }
            value["account"] = vm.numberToFixed(sum);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>
